import { isFunction } from '@polkadot/util';
export class Combinator {
    constructor(fns, callback) {
        this.__internal__allHasFired = false;
        this.__internal__fired = [];
        this.__internal__fns = [];
        this.__internal__isActive = true;
        this.__internal__results = [];
        this.__internal__subscriptions = [];
        this.__internal__callback = callback;
        // eslint-disable-next-line @typescript-eslint/require-await
        this.__internal__subscriptions = fns.map(async (input, index) => {
            const [fn, ...args] = Array.isArray(input)
                ? input
                : [input];
            this.__internal__fired.push(false);
            this.__internal__fns.push(fn);
            // Not quite 100% how to have a variable number at the front here
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/ban-types
            return fn(...args, this._createCallback(index));
        });
    }
    _allHasFired() {
        this.__internal__allHasFired ||= this.__internal__fired.filter((hasFired) => !hasFired).length === 0;
        return this.__internal__allHasFired;
    }
    _createCallback(index) {
        return (value) => {
            this.__internal__fired[index] = true;
            this.__internal__results[index] = value;
            this._triggerUpdate();
        };
    }
    _triggerUpdate() {
        if (!this.__internal__isActive || !isFunction(this.__internal__callback) || !this._allHasFired()) {
            return;
        }
        try {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.__internal__callback(this.__internal__results);
        }
        catch {
            // swallow, we don't want the handler to trip us up
        }
    }
    unsubscribe() {
        if (!this.__internal__isActive) {
            return;
        }
        this.__internal__isActive = false;
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        this.__internal__subscriptions.forEach(async (subscription) => {
            try {
                const unsubscribe = await subscription;
                if (isFunction(unsubscribe)) {
                    unsubscribe();
                }
            }
            catch {
                // ignore
            }
        });
    }
}
